<div class="text-fixed-medium" [innerHtml]="cmsContent"></div>
